let _isDown = false;

export const isPianoPointerDown = () => _isDown;
export const setPianoPointerDown = (v: boolean) => { _isDown = v; };
